import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { TemplateDetails } from "./routes";

export default store => ({
  path: "external-assessments/templates",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "external-assessments-templates" */ "./components"
      ),
    ]).then(([importedModule0]) => importedModule0.default)
  ),
  childRoutes: [TemplateDetails(store)],
});
